// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/learn-ai/top-banner-lai.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/learn-ai/AI-projects-meritus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/images/learn-ai/learn-ai-mob.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/images//learn-ai/discoverAI-mob-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-banner-lai {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 36.6vw;
  position: relative;
}

.banner-txt-lai {
  position: absolute;
  top: 30%;
  left: 15%;
  width: 20rem;
}

.banner-txt-lai h1 {
  color: #fff;
  font-size: 4rem;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 1px;
}

.banner-txt-lai h1 span {
  font-size: 6rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.banner-txt-lai p {
  color: #fff;
  letter-spacing: 1px;
}

/* tab  */
.stem-shop-tab li {
  color: #000;
  text-transform: inherit;
  font-weight: 500;
}

.lai-tab-wrapper {
  margin-bottom: 5% !important;
}

/* Coding Projects Section */
.cps-bg-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 450px;
  width: 100%;
  position: relative;
}

.cps-section-content {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-20%, -50%);
}

.cps-head h2 {
  color: #fff;
}

.cps-head h2 span {
  color: var(--DYello);
}

.cps-head h2::after {
  content: "";
  position: absolute;
  left: 30%;
  bottom: -30%;
  width: 40%;
  height: 5px;
  background-color: #fff;
  border-radius: 5px;
  border: medium none currentColor;
  border: initial;
}

.cps-sub-head {
  padding: 5% 10% 0% 10%;
}

.cps-sub-head p {
  color: #fff;
}

.cps-sub-head p span {
  font-weight: 700;
}

.explore-project-hub-btn {
  color: #000;
  background-color: #a7cb4d;
  border-radius: 30px;
  border: medium none currentColor;
  border: initial;
  font-weight: 700;
  padding: 10px 25px;
}

.cstem-gif-content img {
  height: 270px;
  width: auto;
  text-transform: capitalize;
}

/* Gifting Options Section */
.card-slider {
  background-color: #ebe8ff;
}

/* Carousel Customixations */
.gift-cards-slider .owl-dots .owl-dot.active span {
  background: #8e7edf !important;
}
.gift-cards-slider .owl-dots .owl-dot span {
  width: 5rem;
  margin: 5px -1px;
  height: 5px;
  background: #c4bdef !important;
}

/* Video testimonial section  */
.learners-testimonials {
  background-color: #f4f4f4;
}

.playbits-video-tutorials {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0px;
}

.load-more-products .btn {
  color: #fff;
  background-color: var(--dBlue);
  border-radius: 30px;
  border: medium none currentColor;
  border: initial;
  font-weight: 700;
  padding: 10px 25px;
  margin-top: 20px;
}

@media (max-width: 1024px) {
  /* .top-banner-lai {
    height: 30vh;
  } */

  .banner-txt-lai {
    top: 10%;
  }

  .cps-bg-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 112vw;
  }

  .cps-section-content {
    position: absolute;
    top: 23%;
    left: 10%;
    transform: translate(-5%, -50%);
  }
}

@media (max-width: 576px) {
  .top-banner-lai {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 62vh !important;
  }

  .banner-txt-lai {
    left: 10%;
  }

  .banner-txt-lai h1 {
    font-size: 2rem;
  }

  .banner-txt-lai h1 span {
    font-size: 4rem;
  }

  .cps-bg-img {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    height: 96.3vw;
    background-size: contain;
  }

  .cps-section-content {
    top: 30%;
    left: 0%;
    padding: 0 15px;
    transform: translate(0%, -50%);
  }

  .cps-head h2 {
    font-size: 20px;
  }

  .cps-sub-head p {
    padding-top: 10px;
  }

  .explore-project-hub-btn {
    padding: 10px;
  }

  .cps-head h2::after {
    bottom: -40%;
  }

  .lai-product-card {
    height: 500px;
  }

  .card-img-top {
    height: 200px !important;
    width: 100% !important;
  }

  .load-more-products .btn {
    margin-top: 0;
    margin-top: initial;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .cps-bg-img {
    height: 335px;
  }

  .cps-head h2 {
    font-size: 28px;
  }

  .cps-sub-head {
    padding: 3% 10% 0% 10%;
  }

  .cps-section-content {
    top: 58%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/learn-ai/LearnAI.css"],"names":[],"mappings":"AAAA;EACE,yDAA2E;EAC3E,wBAAwB;EACxB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,uBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,yDAAgF;EAChF,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gCAAa;EAAb,eAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gCAAa;EAAb,eAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAa;EAAb,eAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;;KAEG;;EAEH;IACE,QAAQ;EACV;;EAEA;IACE,yDAAyE;IACzE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,yDAAyE;IACzE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yDAA+E;IAC/E,cAAc;IACd,wBAAwB;EAC1B;;EAEA;IACE,QAAQ;IACR,QAAQ;IACR,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,aAAiB;IAAjB,mBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".top-banner-lai {\n  background-image: url(\"../../../public/images/learn-ai/top-banner-lai.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 36.6vw;\n  position: relative;\n}\n\n.banner-txt-lai {\n  position: absolute;\n  top: 30%;\n  left: 15%;\n  width: 20rem;\n}\n\n.banner-txt-lai h1 {\n  color: #fff;\n  font-size: 4rem;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: 1px;\n}\n\n.banner-txt-lai h1 span {\n  font-size: 6rem;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.banner-txt-lai p {\n  color: #fff;\n  letter-spacing: 1px;\n}\n\n/* tab  */\n.stem-shop-tab li {\n  color: #000;\n  text-transform: unset;\n  font-weight: 500;\n}\n\n.lai-tab-wrapper {\n  margin-bottom: 5% !important;\n}\n\n/* Coding Projects Section */\n.cps-bg-img {\n  background-image: url(\"../../../public/images/learn-ai/AI-projects-meritus.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 450px;\n  width: 100%;\n  position: relative;\n}\n\n.cps-section-content {\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-20%, -50%);\n}\n\n.cps-head h2 {\n  color: #fff;\n}\n\n.cps-head h2 span {\n  color: var(--DYello);\n}\n\n.cps-head h2::after {\n  content: \"\";\n  position: absolute;\n  left: 30%;\n  bottom: -30%;\n  width: 40%;\n  height: 5px;\n  background-color: #fff;\n  border-radius: 5px;\n  border: unset;\n}\n\n.cps-sub-head {\n  padding: 5% 10% 0% 10%;\n}\n\n.cps-sub-head p {\n  color: #fff;\n}\n\n.cps-sub-head p span {\n  font-weight: 700;\n}\n\n.explore-project-hub-btn {\n  color: #000;\n  background-color: #a7cb4d;\n  border-radius: 30px;\n  border: unset;\n  font-weight: 700;\n  padding: 10px 25px;\n}\n\n.cstem-gif-content img {\n  height: 270px;\n  width: auto;\n  text-transform: capitalize;\n}\n\n/* Gifting Options Section */\n.card-slider {\n  background-color: #ebe8ff;\n}\n\n/* Carousel Customixations */\n.gift-cards-slider .owl-dots .owl-dot.active span {\n  background: #8e7edf !important;\n}\n.gift-cards-slider .owl-dots .owl-dot span {\n  width: 5rem;\n  margin: 5px -1px;\n  height: 5px;\n  background: #c4bdef !important;\n}\n\n/* Video testimonial section  */\n.learners-testimonials {\n  background-color: #f4f4f4;\n}\n\n.playbits-video-tutorials {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 50px 0px;\n}\n\n.load-more-products .btn {\n  color: #fff;\n  background-color: var(--dBlue);\n  border-radius: 30px;\n  border: unset;\n  font-weight: 700;\n  padding: 10px 25px;\n  margin-top: 20px;\n}\n\n@media (max-width: 1024px) {\n  /* .top-banner-lai {\n    height: 30vh;\n  } */\n\n  .banner-txt-lai {\n    top: 10%;\n  }\n\n  .cps-bg-img {\n    background-image: url(\"../../../public/images/learn-ai/learn-ai-mob.png\");\n    height: 112vw;\n  }\n\n  .cps-section-content {\n    position: absolute;\n    top: 23%;\n    left: 10%;\n    transform: translate(-5%, -50%);\n  }\n}\n\n@media (max-width: 576px) {\n  .top-banner-lai {\n    background-image: url(\"../../../public/images/learn-ai/learn-ai-mob.png\");\n    height: 62vh !important;\n  }\n\n  .banner-txt-lai {\n    left: 10%;\n  }\n\n  .banner-txt-lai h1 {\n    font-size: 2rem;\n  }\n\n  .banner-txt-lai h1 span {\n    font-size: 4rem;\n  }\n\n  .cps-bg-img {\n    background-image: url(\"../../../public/images//learn-ai/discoverAI-mob-bg.png\");\n    height: 96.3vw;\n    background-size: contain;\n  }\n\n  .cps-section-content {\n    top: 30%;\n    left: 0%;\n    padding: 0 15px;\n    transform: translate(0%, -50%);\n  }\n\n  .cps-head h2 {\n    font-size: 20px;\n  }\n\n  .cps-sub-head p {\n    padding-top: 10px;\n  }\n\n  .explore-project-hub-btn {\n    padding: 10px;\n  }\n\n  .cps-head h2::after {\n    bottom: -40%;\n  }\n\n  .lai-product-card {\n    height: 500px;\n  }\n\n  .card-img-top {\n    height: 200px !important;\n    width: 100% !important;\n  }\n\n  .load-more-products .btn {\n    margin-top: unset;\n  }\n}\n\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\n  .cps-bg-img {\n    height: 335px;\n  }\n\n  .cps-head h2 {\n    font-size: 28px;\n  }\n\n  .cps-sub-head {\n    padding: 3% 10% 0% 10%;\n  }\n\n  .cps-section-content {\n    top: 58%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
